/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    "use strict";
    import CustomerNameFormat = Meevo.Model.CustomerNameDisplayFormatEnum;
    import ILoggingService = Meevo.Components.Logging.ILoggingService;
    import ICommonDataService = Meevo.Components.CommonClasses.ICommonDataService;
    import NotificationTags = Meevo.Components.Common.NotificationTags;

    /**
    * Main Section of Walkin Manager Settings
    */
    export class MainSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {
        availableMinuteValues: Array<number> = [];
        public defaultTermsValue: string = 'These are the terms and conditions';
        public popularServiceLookup: Meevo.Model.Service;
        public customerNameFormat: any = CustomerNameFormat;
        public mileageLimitOptions: Array<number> = [5, 10, 20, 50];
        public timeLimitOptions: Array<number> = [15, 30, 45, 60];
        public bookFullTags: Array<string> = [NotificationTags.WALKIN_URL, NotificationTags.BUSINESS_NAME];
        private notificationKeys: Array<string> = [
            'customConfirmationPageMessage',
            'appointmentBookFullMessage'
        ];

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public activate(): void {
            let {
                enableClientEmailLookupForWalkIn,
                waitListAddingEnabled,
                hideAnyGenderOptions
            } = this.model;

            //this.model.enableClientEmailLookupForWalkIn = this.convertBooleanToObjectState(enableClientEmailLookupForWalkIn);
            //this.model.waitListAddingEnabled = this.convertBooleanToObjectState(waitListAddingEnabled);
            this.availableMinuteValues = MainSection.generateMinutesValues();

            if (this.model.termsAndConditions.objectStateEnum === 0) {
                this.model.termsAndConditions.termsAndConditionsText = 'These are the terms and conditions';
                this.model.termsAndConditions.objectStateEnum = Meevo.Model.ObjectStateEnum.Active;
                this.model.termsAndConditions.entityVersion = 1;
            }

            if (typeof this.model.publicOnlineWaitListUrl === 'undefined') {
                this.model.publicOnlineWaitListUrl = '';
            }

            for (let i = 0; i < 3; i++) {
              this.model[`promotion${i+1}Title`] = this.model.promotionalContents[i].displayName;
              this.model[`promotion${i+1}Description`] = this.model.promotionalContents[i].description;
            }

            if (this.model.walkInMostPopularServiceId) {
                this.dataService['getItem']('service', this.model.walkInMostPopularServiceId)
                    .then((response:Meevo.Model.Service) => {
                        this.popularServiceLookup = response;
                    })
            }

        }

        /**
         * Prepare model to save
         * @returns {Meevo.Model.IWalkInSettings} model
         * */
        public preSave (): Meevo.Model.IWalkInSettings {
            //this.model.enableClientEmailLookupForWalkIn = this.convertObjectStateToBoolean(this.model.enableClientEmailLookupForWalkIn);
            //this.model.waitListAddingEnabled = this.convertObjectStateToBoolean(this.model.waitListAddingEnabled);
            if (this.model.termsAndConditions.termsAndConditionsText === '') {
                this.model.termsAndConditions.termsAndConditionsText = this.defaultTermsValue;
            }
            this.model.walkInMostPopularServiceId = this.popularServiceLookup ? this.popularServiceLookup.id : null;

            return this.model;
        }

        /**
         * Default handler on section edit cancellation
         * Reset text for all notification settings which are present on the page.
         * */
        public rollbackChanges(): void {
            super.rollbackChanges();

            this.notificationKeys.forEach((item) => {
                this.resetNotification(item);
            });
        }

        /**
         * Generate array of values for select
         * @returns {Array<number>} list of available values
         * */
        static generateMinutesValues (): Array<number> {
            let arr = [], value = 15;

            while (value < 721) {
                arr.push(value);
                value += 15;
            }

            return arr;
        }
        
        public get fileTypesEnum() {
            return Meevo.Model.FileTypes;
        }
    }

}